import React from 'react';

export const GradeAttendanceTabSkeleton = () => {
  return (
    <div className="animate-pulse">
      {/* Stats Cards and Graph Section */}
      <div className="grid grid-cols-1 lg:grid-cols-7 gap-6 mb-8">
        {/* Stats Cards Column */}
        <div className="lg:col-span-2 grid grid-rows-2 gap-6 h-[280px]">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-[#E4E8EA] flex flex-col justify-center">
            <div className="h-3 w-32 bg-gray-200 rounded mb-3"></div>
            <div className="h-10 w-20 bg-gray-200 rounded"></div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-[#E4E8EA] flex flex-col justify-center">
            <div className="h-3 w-32 bg-gray-200 rounded mb-3"></div>
            <div className="h-10 w-20 bg-gray-200 rounded"></div>
            <div className="h-3 w-40 bg-gray-200 rounded mt-1"></div>
          </div>
        </div>

        {/* Graph Column */}
        <div className="lg:col-span-5">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-[#E4E8EA] h-[280px]">
            <div className="flex items-center justify-between mb-6">
              <div className="h-3 w-32 bg-gray-200 rounded"></div>
            </div>
            <div className="h-[220px] bg-gray-100 rounded-lg"></div>
          </div>
        </div>
      </div>

      {/* Daily Records Table */}
      <div className="bg-white rounded-xl shadow-sm border border-[#E4E8EA]">
        <div className="px-6 py-4 border-b border-[#E4E8EA]">
          <div className="h-5 w-48 bg-gray-200 rounded"></div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-[#F5F8F9]">
                {Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <th key={i} scope="col" className="px-6 py-4 text-left">
                      <div className="h-5 w-24 bg-gray-200 rounded"></div>
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E4E8EA]">
              {Array(5)
                .fill(0)
                .map((_, rowIndex) => (
                  <tr key={rowIndex} className="hover:bg-[#F5F8F9]/50">
                    {Array(5)
                      .fill(0)
                      .map((_, cellIndex) => (
                        <td key={cellIndex} className="px-6 py-2.5">
                          <div
                            className="h-6 bg-gray-200 rounded-md animate-pulse"
                            style={{
                              width: `${60 + (rowIndex % 4) * 10}px`,
                              animationDelay: `${rowIndex * 0.1 + cellIndex * 0.05}s`,
                            }}
                          ></div>
                        </td>
                      ))}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
